import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@mui/material';
import { trakrefBlue, trakrefDisabledBlue, focusColor } from '../../../color_utils';
import { trakrefFontFamilyBold } from '../../../utils';

const ButtonNoBorder = ({
    id,
    buttonText,
    onClick,
    disabled,
    fullWidth,
    width,
    size,
    sx,
}) => {
    const primaryButtonStyle = {
        '&.MuiButton-root': {
            fontFamily: trakrefFontFamilyBold,
            color: '#FFF',
            letterSpacing: '1.2px',
        },
        '&:focus': { outline: `3px solid ${focusColor}` }
    };
    
    return (
        <Button
            id={id}
            variant="text"
            size={size}
            onClick={onClick}
            fullWidth={fullWidth}
            sx={{ ...primaryButtonStyle, width: `${width}%`, ...sx }}
            disabled={disabled}
        >
            {buttonText}
        </Button>
    );
};

ButtonNoBorder.propTypes = {
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    id: PropTypes.string,
    useLargeButton: PropTypes.bool,
    width: PropTypes.number,
    size: PropTypes.string,
    sx: PropTypes.object,
};

ButtonNoBorder.defaultProps = {
    disabled: false,
    fullWidth: false,
    id: "",
    width: null,
    useLargeButton: false,
    size: "medium",
    sx: {}
};

export default ButtonNoBorder;
